export type BookingTarget = {
    bookingId: number | string
    partnerId?: number
}

export const getBookingTarget = (
    bookingIds?: readonly number[],
    visitGroupId?: string
): BookingTarget | undefined => {
    if (visitGroupId && isVisitGroupId(visitGroupId)) {
        return { bookingId: visitGroupId }
    }

    const [bookingId, partnerId] = bookingIds ?? []

    if (bookingId == null || !isValidBookingId(bookingId)) {
        return undefined
    }

    return partnerId == null || !isValidBookingId(partnerId)
        ? { bookingId }
        : { bookingId, partnerId }
}

export const isValidBookingId = (bookingId: number): boolean => {
    return Number.isSafeInteger(bookingId) && bookingId > 0
}

export const isVisitGroupId = (id: string): boolean => {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)
}

export const parseBookingReference = (id: string): number | string => {
    return /^\d+$/.test(id) && isValidBookingId(Number(id)) ? Number(id) : id
}
